export default "__VITE_ASSET__D03o08rg__"